// src/hooks/useActivityTicker.js
import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";

export const useActivityTicker = () => {
  const [activities, setActivities] = useState([]);
  const [idx, setIdx] = useState(0);
  const location = useLocation();

  const fetchActivities = useCallback(async () => {
    try {
      const res = await axiosInstance.get("/activity/ongoing");
      const running = res.data.filter(a => a.status === "IN_PROGRESS");
      setActivities(running);
    } catch {}
  }, []);

  // The layout remains mounted while child routes change, so refresh the
  // header activity state on every SPA navigation as well as on first mount.
  useEffect(() => {
    fetchActivities();
  }, [fetchActivities, location.pathname]);

 

  // manual refresh via custom event
  useEffect(() => {
    window.addEventListener("refreshActivities", fetchActivities);
    return () => window.removeEventListener("refreshActivities", fetchActivities);
  }, [fetchActivities]);

  useEffect(() => {
    setIdx(currentIdx => currentIdx >= activities.length ? 0 : currentIdx);
  }, [activities]);

  // rotate ticker
  useEffect(() => {
    if (activities.length < 2) return;
    const id = setInterval(() => {
      setIdx(i => (i + 1) % activities.length);
    }, 6000);
    return () => clearInterval(id);
  }, [activities]);

  return {
    currentActivity: activities[idx]?.message
      || activities[idx]?.actionType
      || null,
    hasActivities: activities.length > 0,
  };
};
